module.exports = __webpack_public_path__ + "img/contact_us_2.dea272f3.jpg";